<template lang="pug">
  v-tab.yz-tab(:class="tabClasses" :disabled="disabled" v-bind="$attrs" v-on="$listeners")
    .yz-tab__content
      yz-icon.yz-tab__icon(v-if="icon" :size="16") {{ icon }}
      span.yz-tab__text {{ label || $slots.default }}
      .yz-tab__badge.yz-badge.px-3(v-if="badge !== null && badge !== undefined") {{ badge }}
    slot
</template>

<script>
export default {
  name: 'YzTab',
  inject: {
    yzTabsType: {
      default: 'line'
    },
  },
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    badge: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tabClasses() {
      const classes = []

      if (this.yzTabsType) {
        classes.push(`yz-tab--${this.yzTabsType}`)
      }

      if (this.disabled) {
        classes.push('yz-tab--disabled')
      }

      return classes
    }
  }
}
</script>

<style scoped>
/* Base YzTab styles */
.yz-tab {
  position: relative;
}

.yz-tab__content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.yz-tab__text {
  display: flex;
  align-items: center;
}

.yz-tab__icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>